import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {POLL, POLL_WEB} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('polls.title'),
                url: POLL,
                datatableWrapper: this.$isAdmin() ? true : false,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('description'),
                        type: 'text',
                        key: 'description',
                        isVisible: true,
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: this.$isAdmin() ,
                        modifier: status => {
                            return `<span class="badge badge-pill badge-${status.class}">
                                ${status.translated_name}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: this.$isAdmin(),
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('status'),
                        type: "checkbox",
                        key: "status",
                        option: [],
                        listValueField: 'value'
                    },
                ].filter(filter => {
                    return this.$isAdmin();
                }),
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('polls.start_poll'),
                        key: "start_poll",
                        name: 'start_poll',
                        url: POLL_WEB,
                        modifier: row => {
                            return row.status?.name === 'status_active' && row.questions && row.questions.length > 0;
                        }
                    },
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: POLL_WEB,
                    },
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-poll-modal',
                        modalId: 'poll-modal',
                        url: POLL,
                        name: 'edit',
                        modifier: row => this.$can('update_poll') && (this.$isAdmin())
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'poll-modal',
                        url: POLL,
                        name: 'delete',
                        modifier: row => this.$can('delete_poll') && (this.$isAdmin())
                    },
                ],
            }
        }
    }
}
